module.exports = __webpack_public_path__ + "img/1504807044.718950bf.jpg";